module.exports = __webpack_public_path__ + "img/正常发送.32bc5654.svg";